/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './endpoints/bulk-create-team-members';
import './endpoints/bulk-retrieve-team-members';
import './endpoints/bulk-update-team-members';
import './endpoints/create-team-member';
import './endpoints/deactivate-team-member';
import './endpoints/retrieve-team-member';
import './endpoints/retrieve-team-member-invitation';
import './endpoints/retrieve-wage-setting';
import './endpoints/search-team-members';
import './endpoints/send-team-member-invitation';
import './endpoints/update-team-member';
import './endpoints/update-wage-setting';
import './endpoints/create-job';
import './endpoints/update-job';
import './endpoints/retrieve-job';
import './endpoints/list-jobs';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "TeamService": {
            "methods": {
              "BulkCreateTeamMembers": {
                "requestType": ".squareup.team_api.BulkCreateTeamMembersRequest",
                "responseType": ".squareup.team_api.BulkCreateTeamMembersResponse"
              },
              "BulkRetrieveTeamMembers": {
                "requestType": ".squareup.team_api.BulkRetrieveTeamMembersRequest",
                "responseType": ".squareup.team_api.BulkRetrieveTeamMembersResponse"
              },
              "BulkUpdateTeamMembers": {
                "requestType": ".squareup.team_api.BulkUpdateTeamMembersRequest",
                "responseType": ".squareup.team_api.BulkUpdateTeamMembersResponse"
              },
              "CreateTeamMember": {
                "requestType": ".squareup.team_api.CreateTeamMemberRequest",
                "responseType": ".squareup.team_api.CreateTeamMemberResponse"
              },
              "DeactivateTeamMember": {
                "requestType": ".squareup.team_api.DeactivateTeamMemberRequest",
                "responseType": ".squareup.team_api.DeactivateTeamMemberResponse"
              },
              "RetrieveTeamMember": {
                "requestType": ".squareup.team_api.RetrieveTeamMemberRequest",
                "responseType": ".squareup.team_api.RetrieveTeamMemberResponse"
              },
              "RetrieveTeamMemberInvitation": {
                "requestType": ".squareup.team_api.RetrieveTeamMemberInvitationRequest",
                "responseType": ".squareup.team_api.RetrieveTeamMemberInvitationResponse"
              },
              "RetrieveWageSetting": {
                "requestType": ".squareup.team_api.RetrieveWageSettingRequest",
                "responseType": ".squareup.team_api.RetrieveWageSettingResponse"
              },
              "SearchTeamMembers": {
                "requestType": ".squareup.team_api.SearchTeamMembersRequest",
                "responseType": ".squareup.team_api.SearchTeamMembersResponse"
              },
              "SendTeamMemberInvitation": {
                "requestType": ".squareup.team_api.SendTeamMemberInvitationRequest",
                "responseType": ".squareup.team_api.SendTeamMemberInvitationResponse"
              },
              "UpdateTeamMember": {
                "requestType": ".squareup.team_api.UpdateTeamMemberRequest",
                "responseType": ".squareup.team_api.UpdateTeamMemberResponse"
              },
              "UpdateWageSetting": {
                "requestType": ".squareup.team_api.UpdateWageSettingRequest",
                "responseType": ".squareup.team_api.UpdateWageSettingResponse"
              },
              "CreateJob": {
                "requestType": ".squareup.team_api.CreateJobRequest",
                "responseType": ".squareup.team_api.CreateJobResponse"
              },
              "UpdateJob": {
                "requestType": ".squareup.team_api.UpdateJobRequest",
                "responseType": ".squareup.team_api.UpdateJobResponse"
              },
              "RetrieveJob": {
                "requestType": ".squareup.team_api.RetrieveJobRequest",
                "responseType": ".squareup.team_api.RetrieveJobResponse"
              },
              "ListJobs": {
                "requestType": ".squareup.team_api.ListJobsRequest",
                "responseType": ".squareup.team_api.ListJobsResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.TeamService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TeamService @ squareup/team_api/service.proto at 35:1
 */
export const TeamService = $root.lookupService('squareup.team_api.TeamService');